import { forwardRef, ForwardRefRenderFunction, HTMLProps } from 'react'

import { InputBirthday } from '../../theme/theme'
import { calendar } from './wordings'

const DateInput: ForwardRefRenderFunction<HTMLInputElement, HTMLProps<HTMLInputElement>> = (
  { type, ...props },
  ref
) => {
  return (
    <div className="flex flex-col items-center justify-between">
      <InputBirthday
        theme={undefined} 
        ref={ref as any}
        name={type}
        type="tel"
        pattern="\d*"
        className="w-14 text-center bg-transparent text-4xl font-bold saira"
        maxLength={2}
        {...props}
      />
      <p className="text-center text-sm saira">{calendar[type as keyof typeof calendar]}</p>
    </div>
  )
}

const DateInputWithRef = forwardRef(DateInput)

export default DateInputWithRef
